import React from 'react';

import { Layout } from './Layout';

export function Root() {
  return <Layout />
}
